import React, { useMemo, useState, useRef, useCallback, useEffect } from 'react'

//* Style
import NewsItemStyle from './style'

//* Components
import Text from 'components/common/Text'
import CustomLink from 'components/common/CustomLink'
import AnimationWrap from 'components/common/AnimationWrap'
import Line from 'components/common/Line'

//* HOC's
import { withUIContext } from 'context'

//* Helpers
import { slideDown, changeWidth } from 'helpers/_gsapFunctions'

const NewsItem = ({ itemData, winWidth }) => {
	//! States
	const [secObj, setSecObj] = useState()

	//! Refs
	const items = useRef([])
	const dateRef = useRef()
	const titleRef = useRef()
	const descriptionRef = useRef()
	const lineRef = useRef()

	useEffect(() => {
		if (items?.current) {
			setSecObj([items.current])
		}
	}, [items])

	const startAnimeArr = useCallback((x) => {
		if (x) {
			//! changeWidth(item, stagger, delay)
			slideDown([dateRef.current, titleRef.current, descriptionRef.current], 0.2)
			//! changeWidth(item)
			changeWidth(lineRef.current)
		}
	}, [])

	const storeDate = useMemo(() => {
		return (
			<div className='overflowHidden animWrap'>
				<Text className={'h9 maisonMedium date translate-200'} text={itemData.date.replace(',', ', ')} ref={dateRef} />
			</div>
		)
	}, [itemData])

	return (
		<NewsItemStyle>
			<AnimationWrap state={secObj} startAnimeArr={startAnimeArr} dependency={winWidth}>
				<CustomLink url={'/news/' + itemData.slug} ref={items}>
					{storeDate}
					<div className='FlexBox spaceBetween short-info'>
						<div className='overflowHidden animWrap'>
							<Text className={'h5 maisonSemiBold newsItemTitle translate-200'} text={itemData.title} ref={titleRef} />
						</div>
						<div className='overflowHidden animWrap'>
							<Text
								className={'h9 maisonMedium newsItemDescription translate-200'}
								text={itemData.short_description}
								ref={descriptionRef}
							/>
						</div>
					</div>
					{winWidth < 1024 ? (
						<div ref={lineRef} className='animStartStateWidth'>
							<Line color='orange' />
						</div>
					) : (
						<div ref={lineRef} className='animStartStateWidth'>
							<Line />
						</div>
					)}
				</CustomLink>
			</AnimationWrap>
		</NewsItemStyle>
	)
}

export default withUIContext(NewsItem, ['winWidth'])
